import { render } from "./GuideUploadModal.vue?vue&type=template&id=07bca520"
import script from "./GuideUploadModal.vue?vue&type=script&lang=js"
export * from "./GuideUploadModal.vue?vue&type=script&lang=js"
script.render = render

export default script